import React from 'react';
import BalanceOnHandExpectedInfoContainer from './BalanceOnHandExpectedInfoContainer';
import BalanceOnHandRouteInfoContainer from './BalanceOnHandRouteInfoContainer';
import BalanceOnHandCurrentInfoContainer from './BalanceOnHandCurrentInfoContainer';
import { BalanceOnHandViewInfoContainerStyle } from './BalanceOnHandViewInfoContainer.styles';

function BalanceOnHandViewInfoContainer() {
  return (
    <BalanceOnHandViewInfoContainerStyle>
      <div style={{ float: 'left' }}>
        <BalanceOnHandCurrentInfoContainer />
        <BalanceOnHandExpectedInfoContainer />
      </div>
      <div style={{ float: 'left' }}>
        <BalanceOnHandRouteInfoContainer />
      </div>
    </BalanceOnHandViewInfoContainerStyle>
  );
}

export default BalanceOnHandViewInfoContainer;
